// Load all the controllers within this directory and all subdirectories.
// Controller files must be named *_controller.ts.

import { Application } from "stimulus"
import { definitionsFromContext } from "stimulus/webpack-helpers"

const application: Application = Application.start()

const context = require.context(".", true, /_controller\.ts$/)

application.load(definitionsFromContext(context))